import { Component, Inject, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {
  code: String;
  description: String;
  type: String;
}

@Component({
  selector: "nup-reason-dialog", 
  templateUrl: "nup-reason-dialog.html", 
})
export class NupReasonDialog implements AfterViewInit { 
  editNew: String = "New";
  itemDialogForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<NupReasonDialog>, 
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.itemDialogForm = new FormGroup({
      code: new FormControl("", [Validators.required]),
      description: new FormControl("", [Validators.required]), 
    });


    if (data.code) {
      this.itemDialogForm.controls.code.setValue(data.code);
      this.editNew = "Edit";
    }

    if (data.description) {
      this.itemDialogForm.controls.description.setValue(data.description);
    }
  }

  save() {
    if (this.itemDialogForm.valid) {
      this.dialogRef.close({
        code: this.itemDialogForm.controls.code.value, 
        description: this.itemDialogForm.controls.description.value,
      });
    }
  }

  ngAfterViewInit() {}
}
